import { PaymentTypes } from "../../../_models";

export enum PaperPaymentType {
  cash = "Cash",
  check = "Check",
}



// WEBPACK FOOTER //
// ./src/app/admin/receipt/receipt-page-models/PaperPaymentType.ts